export const DATE_FORMAT_PATTERN_WITH_TIME = 'MM/dd/yyyy - hh:mm a';
export const DATE_FORMAT_PATTERN_WITHOUT_TIME = 'MMMM d, yyyy';
